export enum ScreenComponent {
	Shop = 'Shop',
	Product = 'Product',
	Orders = 'Orders',
	Contact = 'Contact_Us',
	Cart = 'Cart',
	Register = 'Register',
	Login = 'Login',
	Portal = 'Portal',
	ThemePreview = 'Theme_Preview',
	// Custom screens (add new custom screens here)
	CapeRootsHome = 'CapeRootsHome',
	CapeRootsRestaurants = 'CapeRootsRestaurants',
}

export enum PortalScreenComponent {
	Dashboard = "Dashboard",
	Products = "Products",
	Orders = "Orders",
	Users = "Users",
	Roles = "Roles",
	Analytics = "Analytics",
	Customers = "Customers",
}
